<template>
  <div class="custom-tree-bd">
    <el-tree
      ref="tree"
      :data="data"
      highlight-current
      :default-expanded-keys="expandedKeys"
      :node-key="nodeKey"
      v-bind="$attrs"
      v-on="$listeners"
      @node-click="handleNode"
      :filter-node-method="filterNode"
    >
      <div class="custom-tree-node" slot-scope="{ node, data }">
        <div class="line1">
          <slot name="label" v-bind="{ node, data }">{{ node.label }}</slot>
        </div>
        <div v-if="action && val && val[nodeKey] === data[nodeKey]">
          <el-button v-if="action.add" type="text" size="mini" @click.stop="handleAction('add', data, node)"><i class="icon icon-add"></i></el-button>
          <el-button v-if="action.edit" type="text" size="mini" @click.stop="handleAction('edit', data, node)"><i class="icon icon-bianji"></i></el-button>
          <el-button v-if="action.delete" type="text" size="mini" @click.stop="handleAction('delete', data, node)"><i class="icon icon-shanchu"></i></el-button>
        </div>
      </div>
    </el-tree>
  </div>
</template>

<script>
export default {
  props: {
    data: Array, // 列表数据
    value: Object, // 绑定值
    nodeKey: String, // key字段
    action: Object, // 操作
    filterKeys: Array, // 过滤字段
    listener: String, // 监听过滤
    default: Boolean, // 默认选择第一项
  },
  data() {
    return {
      val: this.value || {},
      expandedKeys: []
    };
  },
  watch: {
    value() {
      this.val = this.value;
    },
    data() {
      this.init();
      this.handleFilter(this.listener);
    },
    listener(newVal) {
      this.handleFilter(newVal);
    }
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init: function () {
      if (this.val && !this.val[this.nodeKey] && this.default) {
        this.val = this.data && this.data.length ? this.data[0] : {};
        this.$emit('input', this.val);
        this.$emit('handleNode', this.val);
      }
      if (this.val && this.val[this.nodeKey]) {
        this.expandedKeys = [this.val[this.nodeKey]];
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.val[this.nodeKey]);
        });
      }
    },
    // 点击行
    handleNode: function (data) {
      this.val = data;
      this.$emit('input', data);
      this.$emit('handleNode', data);
    },
    // 操作
    handleAction: function (name, data) {
      this.$emit(name, data);
    },
    // 过滤事件
    filterNode: function (keyWord, data) {
      if (!keyWord) {
        return true;
      }
      const valueList = this.filterKeys.map(t => data[t]);
      return valueList.some(t => t.includes(keyWord));
    },
    // 搜索过滤事件
    handleFilter: function (keyWord) {
      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.$refs.tree.filter(keyWord);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  font-size: 12.5px;
  padding-right: 8px;
  color: #6c757d;
}
.el-tree-node.is-current > .el-tree-node__content .custom-tree-node {
  color: #0d9ae0;
}
</style>
